// eslint-disable-next-line no-unused-vars
import api, { baseURL } from "../../../utils/api";
import axios from "axios";

const SHORT_LINK_API_URL = "https://t.prolegion.com/links/short-link";

const getAuthHeaders = () => {
  const token = localStorage.getItem("ProlegionAccessToken");
  return {
    "Content-Type": "application/json",
    "isAdmin": true,
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export const createShortenUrl = (shortenUrlData) => {
  return axios.post(
    SHORT_LINK_API_URL,
    {
      originalUrl: shortenUrlData.originalUrl,
      linkType: shortenUrlData.linkType || "none",
    },
    {
      headers: getAuthHeaders(),
      withCredentials: true,
    }
  );
};


export const getShortenUrls = (page, limit) => {
  return axios.get(SHORT_LINK_API_URL, {
    headers: getAuthHeaders(),
    params: {
      page: page + 1,
      limit: limit,
    },
    withCredentials: true,
  });
};

export const deleteShortenUrl = (id) => {
  return axios.delete(`${SHORT_LINK_API_URL}/${id}`, {
    headers: getAuthHeaders(),
    withCredentials: true,
  });
};

